/* ==============================================
   PERILIFT PRO — LANDING PAGE JS
   assets/perilift-lp.js
   ============================================== */

(function () {
  'use strict';

  /* ---- Image gallery ---- */
  window.periliftSetMainImage = function (thumb) {
    const main = document.getElementById('perilift-main-img');
    if (!main) return;
    main.src = thumb.dataset.src;
    document.querySelectorAll('.perilift-hero__thumb').forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  };

  /* ---- Variant picker ---- */
  window.periliftSelectVariant = function (radio) {
    const variantId = radio.value;
    // Update hidden form input
    const input = document.getElementById('perilift-variant-id');
    if (input) input.value = variantId;
    // Highlight selected card
    document.querySelectorAll('.perilift-hero__variant-card').forEach(card => {
      card.classList.toggle('is-selected', card.dataset.variantId === variantId);
    });
  };

  /* ---- FAQ accordion ---- */
  function initFaq() {
    document.querySelectorAll('.perilift-faq__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const answer = btn.nextElementSibling;

        // Close all
        document.querySelectorAll('.perilift-faq__btn').forEach(other => {
          other.setAttribute('aria-expanded', 'false');
          const otherAnswer = other.nextElementSibling;
          if (otherAnswer) otherAnswer.classList.remove('is-open');
        });

        // Toggle clicked
        if (!expanded) {
          btn.setAttribute('aria-expanded', 'true');
          if (answer) answer.classList.add('is-open');
        }
      });
    });
  }

  /* ---- Sticky ATC bar (optional — shows below fold) ---- */
  function initStickyAtc() {
    const hero = document.querySelector('.perilift-hero');
    const stickyBar = document.getElementById('perilift-sticky-atc');
    if (!hero || !stickyBar) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        stickyBar.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
        stickyBar.style.opacity = entry.isIntersecting ? '0' : '1';
      });
    }, { threshold: 0 });

    observer.observe(hero);
  }

  /* ---- Smooth scroll for anchor CTAs ---- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#perilift"]').forEach(a => {
      a.addEventListener('click', e => {
        const target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---- Simple scroll reveal ---- */
  function initReveal() {
    if (!window.IntersectionObserver) return;
    const els = document.querySelectorAll(
      '.perilift-modes__card, .perilift-timeline__step, .perilift-reviews__card, .perilift-how-to__step'
    );
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    els.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 480ms ease, transform 480ms ease';
      io.observe(el);
    });
  }

  /* ---- Init on DOM ready ---- */
  function init() {
    initFaq();
    initStickyAtc();
    initSmoothScroll();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
